module.exports = __webpack_public_path__ + "img/tuwen.3b1607fa.png";